import ClaimProducts from './ClaimProducts.vue';

export default ClaimProducts;
